<template>
    <div v-if="isreadshow">
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname" min-width="220" fixed></el-table-column>
            <el-table-column label="标段编号" prop="bdcode" min-width="220"></el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="selectnode(scope.row.bdcode,scope.row.procode)">计算报价得分</el-button>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/KaiBiao/getoffer/getlist.json`"></my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            pgData:{
                txtkey:'',
                sortname : 'zbprocode',
                procode:''
            },
            isreadshow:true,
            tableData:[]
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //计算报价得分
        selectnode:function(bdcode){
            var that = this;
            that.$get(`${this.getGetters('bidUrl')}/KaiBiao/getoffer/selectnode.json`,{bdcode:bdcode,procode:this.pgData.procode}, (data, res) => {
                if(data.errorCode=='error'){
                    that.errormsg=data.msg
                    this.goto({
                        path:'./selectnode',
                        query:{
                            bdcode:bdcode,
                            procode:this.pgData.procode
                        }
                    });
                }else if(data.autochosenode){
                    var nodelist=JSON.parse(data.nodelist);
                    this.goto({
                        path:'./selecttbdw',
                        query:{
                            bdcode:bdcode,
                            procode:this.pgData.procode,
                            type:'node',
                            basepriceKey:nodelist[0].basepriceKey,
                            offerscoreKey:nodelist[0].offerscoreKey,
                            mxnodekey:nodelist[0].mxnodekey,
                            name:nodelist[0].name
                        }
                    })  
                }else{
                    this.goto({
                        path:'./selectnode',
                        query:{
                            bdcode:bdcode,
                            procode:this.pgData.procode
                        }
                    });
                }
            });

        }
    },
    created() {
        if(this.$route.query.procode!=undefined){
            this.pgData.procode=this.$route.query.procode
        }
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
